<article class="booking-reason-step-card">
    <header class="booking-reason-step-header">
        <h2
            #heading
            class="booking-step-heading h4 fw-semibold m-0"
            tabindex="-1"
        >
            Select Reason for Visit
        </h2>
    </header>

    @if (eventChoices().length > 0) {
        <section
            class="booking-reason-section"
            data-testid="events-section"
        >
            <h3 class="booking-reason-section-heading booking-reason-section-heading--event h6 fw-semibold">
                Special Events Today
            </h3>
            <ul
                class="booking-choice-list vstack gap-3 list-unstyled m-0"
                [class.booking-choice-list--grid]="gridLayout()"
            >
                @for (choice of eventChoices(); track choice.event.id) {
                    <li>
                        <app-venue-storefront-booking-choice-row
                            [choice]="choice"
                            [gridLayout]="gridLayout()"
                            [date]="search().date"
                            [paymentTerminology]="paymentTerminology()"
                            (choiceSelected)="choiceSelected.emit($event)"
                        />
                    </li>
                }
            </ul>
        </section>
    }

    @if (standardChoice() || reasonsAtIdealTime().length > 0) {
        <section
            class="booking-reason-section"
            data-testid="reasons-at-ideal-time-section"
        >
            <h3 class="booking-reason-section-heading h6 fw-semibold text-secondary">
                Around Your Ideal Time
            </h3>
            <ul
                class="booking-choice-list vstack gap-3 list-unstyled m-0"
                [class.booking-choice-list--grid]="gridLayout()"
            >
                @if (standardChoice(); as choice) {
                    <li>
                        <app-venue-storefront-booking-choice-row
                            [choice]="choice"
                            [gridLayout]="gridLayout()"
                            [date]="search().idealTime"
                            [paymentTerminology]="paymentTerminology()"
                            (choiceSelected)="choiceSelected.emit($event)"
                        />
                    </li>
                }
                @for (choice of reasonsAtIdealTime(); track choice.reason.id) {
                    <li>
                        <app-venue-storefront-booking-choice-row
                            [choice]="choice"
                            [gridLayout]="gridLayout()"
                            [date]="search().idealTime"
                            [paymentTerminology]="paymentTerminology()"
                            (choiceSelected)="choiceSelected.emit($event)"
                        />
                    </li>
                }
            </ul>
        </section>
    }

    @if (earlierReasons().length > 0) {
        <section
            class="booking-reason-section"
            data-testid="earlier-reasons-section"
        >
            <h3 class="booking-reason-section-heading h6 fw-semibold text-secondary">
                Earlier Options
            </h3>
            <ul
                class="booking-choice-list vstack gap-3 list-unstyled m-0"
                [class.booking-choice-list--grid]="gridLayout()"
            >
                @for (choice of earlierReasons(); track choice.reason.id) {
                    <li>
                        <app-venue-storefront-booking-choice-row
                            [choice]="choice"
                            [gridLayout]="gridLayout()"
                            [date]="search().idealTime"
                            [paymentTerminology]="paymentTerminology()"
                            (choiceSelected)="choiceSelected.emit($event)"
                        />
                    </li>
                }
            </ul>
        </section>
    }

    @if (laterReasons().length > 0) {
        <section
            class="booking-reason-section"
            data-testid="later-reasons-section"
        >
            <h3 class="booking-reason-section-heading h6 fw-semibold text-secondary">
                Later Options
            </h3>
            <ul
                class="booking-choice-list vstack gap-3 list-unstyled m-0"
                [class.booking-choice-list--grid]="gridLayout()"
            >
                @for (choice of laterReasons(); track choice.reason.id) {
                    <li>
                        <app-venue-storefront-booking-choice-row
                            [choice]="choice"
                            [gridLayout]="gridLayout()"
                            [date]="search().idealTime"
                            [paymentTerminology]="paymentTerminology()"
                            (choiceSelected)="choiceSelected.emit($event)"
                        />
                    </li>
                }
            </ul>
        </section>
    }
</article>
